export function showFooterWhenContentReady() {
    document.body.classList.add('ud-main-content-ready');
}
